import type { NextPage } from 'next';
import TermsAndConditionsPage from '@containers/TermsAndConditions';
import Head from 'next/head';

const TermsAndConditions: NextPage = () => {
  return (
    <>
      <Head>
        <title>Terms and Conditions | The Cumin Club</title>
      </Head>
      <TermsAndConditionsPage />
    </>
  );
};

export default TermsAndConditions;
